import buildConfig from '../../utils/build-config'
import { OAuthConfig } from './types'

const { getConfig, setConfig } = buildConfig<OAuthConfig>('oauth')

export { setConfig as configureOauth }

export default getConfig
